import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import * as S from './styles';
import { IRegional } from 'interfaces/regional';
import { useTranslation } from 'hooks';

import { translations } from './translations';

import {
  DeleteUserRegionalState,
  DeleteUserRegionalActions,
} from 'store/ducks/settings/users';

interface IGridUserProps {
  regionals: IRegional[] | Record<string, any>[];
  userId: string;
  onSuccess: () => void;
}

interface ItemProps {
  regional: IRegional | Record<string, any>;
  onSelect: (value: number) => void;
  loading: boolean;
}

const Item: React.FC<ItemProps> = ({ regional, onSelect, loading }) => {
  return (
    <S.ItemContainer>
      <S.ItemContent>
        <S.ItemValue>{regional.id || '--'}</S.ItemValue>
        <S.ItemValue>{regional.name || '--'}</S.ItemValue>
        <S.ButtonTrash onClick={() => onSelect(regional.id)}>
          {loading ? <S.Loading /> : <S.IconTrash />}
        </S.ButtonTrash>
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridUserRegional: React.FC<IGridUserProps> = ({
  regionals = [],
  userId,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<number>(0);
  const { getTranslation } = useTranslation(translations);
//   const { loading } = useSelector<RootStateOrAny>(
//     (state) => state.deleteUserregional
//   ) as DeleteUserRegionalState;

  const handleDelete = useCallback(
    (regionalId) => {
      setSelected(regionalId);
      dispatch(DeleteUserRegionalActions.request(userId, regionalId, onSuccess));
    },
    [dispatch, onSuccess, userId]
  );

  return (
    <S.Container>
      {regionals.length > 0 && (
        <>
          <S.Header>
            <S.Label>{getTranslation('codigo')}</S.Label>
            <S.Label>{getTranslation('nome')}</S.Label>
          </S.Header>
          {regionals.map((regional) => (
            <Item
              regional={regional}
              key={regional.id}
              loading={selected === regional.id && false} // loading is not defined in the current context, set to false
              onSelect={handleDelete}
            />
          ))}
        </>
      )}
    </S.Container>
  );
};
